import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import TablesMyRequest from "../views/TablesMyRequest.vue";
import Profile from "../views/Profile.vue";
import Access from "../views/Access.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import ResetPassword from "../views/Recovery.vue";
import VideoCallPublic from "../views/VideoCallPublic.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "mis-solicitudes" },
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/solicitudes",
    name: "solicitudes",
    component: Tables,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/mis-solicitudes",
    name: "mis-solicitudes",
    component: TablesMyRequest,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/perfil",
    name: "perfil",
    component: Profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/acceso",
    name: "Acceso a aplicación web",
    component: Access,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/estadisticas",
    name: "estadisticas",
    component: () => import("../views/Estadisticas.vue"),
    meta: {
      requiresAuth: true,
      requiresProfesional: true,
    },
  },
  {
    path: "/estadisticas-personal",
    name: "estadisticas-personal",
    component: () => import("../views/EstadisticasPersonal.vue"),
    meta: {
      requiresAuth: true,
      requiresPersonal: true,
    },
  },
  {
    path: "/estadisticas-interanuales",
    redirect: "/estadisticas",
  },
  {
    path: "/VideoCallPublic",
    name: "VideoCallPublic",
    component: VideoCallPublic,
  },
  {
    path: "/privacyPolicy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/resetPassword/:token?",
    name: "ResetPassword",
    component: ResetPassword,
    props: true,
    meta: { guest: true }, 
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
